import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const crisisAlertRoutes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forChild(crisisAlertRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class CrisisAlertRoutingModule {
}
